import Button from "@/components/Button/Button";
import styles from "./SettingsBottomBar.module.scss";

interface SettingsBottomBarProps {
  footnote?: string;
  onCancel?: () => void;
  onSave?: () => void;
  cancelText?: string;
  saveText?: string;
  isSaving?: boolean;
}

const SettingsBottomBar = ({
  footnote = "Changes apply to the member app immediately.",
  onCancel,
  onSave,
  cancelText = "CANCEL",
  saveText = "SAVE CHANGES",
  isSaving = false,
}: SettingsBottomBarProps) => {
  return (
    <footer className={styles.bottomActions}>
      <span className={styles.footnote}>{footnote}</span>

      <div className={styles.buttonsGroup}>
        <Button
          type="button"
          outlined
          className={styles.actionBtn}
          onClick={onCancel}
        >
          {cancelText}
        </Button>
        <Button
          type="button"
          className={styles.actionBtn}
          onClick={onSave}
          disabled={isSaving}
        >
          {saveText}
        </Button>
      </div>
    </footer>
  );
};

export default SettingsBottomBar;
